export default "__VITE_ASSET__nvkr7A$e__"